import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { invitationActions } from '../../actions/auth.actions';
import { AuthBackend } from '../../../backend/auth.backend';
import { AuthRoutes } from '../../../constants';
import { Router } from '@angular/router';
import { RouterFacade } from '@rx-applications/shared/data-access';
import { AuthLoggerService } from '../../../services';

@Injectable()
export class InvitationEffects {
  actions$ = inject(Actions);
  authBackend = inject(AuthBackend);
  router = inject(Router);
  routerFacade = inject(RouterFacade);
  authLoggerService = inject(AuthLoggerService);

  validateInvitation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invitationActions.validateInvitation),
      switchMap(({ invitation }) => {
        return this.authBackend.validateInvitation(invitation).pipe(
          map(({ isInvitationValid }) => invitationActions.validateInvitationSucceed({ isInvitationValid })),
          tap(() => this.authLoggerService.landedOnInvitedUserActivationPage()),
          catchError((error) => {
            this.authLoggerService.invitationExpired();
            this.router.navigate([AuthRoutes.InvalidInvitation]);
            return of(invitationActions.validateInvitationFailed({ error }));
          }),
        );
      }),
    ),
  );

  acceptInvitation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invitationActions.acceptInvitation),
      withLatestFrom(this.routerFacade.queryParams$),
      switchMap(([{ acceptInvitation }, queryParams]) => {
        const token: string = queryParams['token'];
        const idpAuthenticated: boolean = queryParams['idpAuthenticated'];
        const acceptInvitationPayload = { ...acceptInvitation, token };
        return this.authBackend.acceptInvitation(acceptInvitationPayload).pipe(
          map(() => invitationActions.acceptInvitationSucceed()),
          tap(() => {
            this.authLoggerService.userSuccessfullyActivated();
            this.router.navigate([AuthRoutes.Login], {
              queryParams: { idpAuthenticated },
            });
          }),
          catchError((error) => {
            this.authLoggerService.userActivationError();
            return of(invitationActions.acceptInvitationFailed({ error }));
          }),
        );
      }),
    ),
  );
}
